/**
 * Split the given string into an ordered list of substrings.
 * A new substring is created when the given string matches the following pattern:
 * {highlight}{/highlight}
 *
 * Everything enclosed by the patter above will than be included in the output array.
 */
export const captureTextToHighlight = (text: string): string[] =>
  text.split(/{highlight\}([^{]*)\{\/highlight\}/g);
